<nav [class.open]="isOpen">
  <span #contextualMenuTrigger
        (click)="$event.stopPropagation()"
        [matMenuTriggerFor]="statusContextualMenu">
    <ng-content></ng-content><i class="fa fa-angle-down"></i>
  </span>
  <mat-menu #statusContextualMenu="matMenu">
    <ng-content select="[menu-items]"></ng-content>
  </mat-menu>
</nav>
